import {
  GET_TASKCATEGORY,
  GET_TASKCATEGORY_SUCCESS,
  GET_TASKCATEGORY_FAIL,
  DELETE_TASKCATEGORY,
  DELETE_TASKCATEGORY_SUCCESS,
  DELETE_TASKCATEGORY_FAIL,
  UPDATE_TASKCATEGORY,
  UPDATE_TASKCATEGORY_SUCCESS,
  UPDATE_TASKCATEGORY_FAIL,
  ADD_NEW_TASKCATEGORY,
  ADD_TASKCATEGORY_SUCCESS,
  ADD_TASKCATEGORY_FAIL,
  TASKCATEGORY_LOADING,
  TASKCATEGORY_RESET,
} from "./actionType";

export const resetTaskCategoryState = (actionType) => ({
  type: TASKCATEGORY_RESET,
  payload: { actionType },
});

export const getTaskCategorySuccess = (actionType, data) => ({
  type: GET_TASKCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getTaskCategoryFail = (actionType, error) => ({
  type: GET_TASKCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getTaskCategory = (data) => ({
  type: GET_TASKCATEGORY,
  payload: data,
});

export const getTaskCategoryLoading = () => ({
  type: TASKCATEGORY_LOADING,
});

export const deleteTaskCategory = (data) => ({
  type: DELETE_TASKCATEGORY,
  payload: data,
});

export const deleteTaskCategorySuccess = (data) => ({
  type: DELETE_TASKCATEGORY_SUCCESS,
  payload: data,
});

export const deleteTaskCategoryFail = (error) => ({
  type: DELETE_TASKCATEGORY_FAIL,
  payload: error,
});

export const updateTaskCategory = (data) => ({
  type: UPDATE_TASKCATEGORY,
  payload: data,
});

export const updateTaskCategoryFail = (error) => ({
  type: UPDATE_TASKCATEGORY_FAIL,
  payload: error,
});

export const updateTaskCategorySuccess = (data) => ({
  type: UPDATE_TASKCATEGORY_SUCCESS,
  payload: data,
});

export const addNewTaskCategory = (data) => ({
  type: ADD_NEW_TASKCATEGORY,
  payload: data,
});

export const addTaskCategorySuccess = (data) => ({
  type: ADD_TASKCATEGORY_SUCCESS,
  payload: data,
});

export const addTaskCategoryFail = (error) => ({
  type: ADD_TASKCATEGORY_FAIL,
  payload: error,
});
